export class RedeemType {
  public eventId: number | null = null;
  public visitorSegmentId: number | null = null;
  public redeemType: RedeemTyping | null = null;

  constructor(data: any) {
    this.eventId = data.eventId;
    this.visitorSegmentId = data.visitorSegmentId;
    this.redeemType = data.redeemType;
  }
}
